"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The EntityOneToMenyReferences model module.
 * @module model/EntityOneToMenyReferences
 * @version 1.1.3-alpha.1
 */
class EntityOneToMenyReferences {
  /**
   * Constructs a new <code>EntityOneToMenyReferences</code>.
   * @alias module:model/EntityOneToMenyReferences
   */
  constructor() {
    EntityOneToMenyReferences.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>EntityOneToMenyReferences</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EntityOneToMenyReferences} obj Optional instance to populate.
   * @return {module:model/EntityOneToMenyReferences} The populated <code>EntityOneToMenyReferences</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EntityOneToMenyReferences();
      if (data.hasOwnProperty('tag_ids')) {
        obj['tag_ids'] = _ApiClient.default.convertToType(data['tag_ids'], ['Number']);
      }
      if (data.hasOwnProperty('available_in_country_ids')) {
        obj['available_in_country_ids'] = _ApiClient.default.convertToType(data['available_in_country_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>EntityOneToMenyReferences</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EntityOneToMenyReferences</code>.
   */
  static validateJSON(data) {
    // ensure the json data is an array
    if (!Array.isArray(data['tag_ids'])) {
      throw new Error("Expected the field `tag_ids` to be an array in the JSON data but got " + data['tag_ids']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['available_in_country_ids'])) {
      throw new Error("Expected the field `available_in_country_ids` to be an array in the JSON data but got " + data['available_in_country_ids']);
    }
    return true;
  }
}

/**
 * @member {Array.<Number>} tag_ids
 */
EntityOneToMenyReferences.prototype['tag_ids'] = undefined;

/**
 * @member {Array.<String>} available_in_country_ids
 */
EntityOneToMenyReferences.prototype['available_in_country_ids'] = undefined;
var _default = EntityOneToMenyReferences;
exports.default = _default;